import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

/**
 * Eligibility for Teamwork Collection (TWC) Predunning — CollectionAddPaymentDetailsPopup.
 * Shown to billing admins in a Jira or Confluence collection during predunning.
 */
export function isEligibleForTWCAddPaymentDetails(context: EditionAwarenessContextType): boolean {
	const { product, edition, isInCollection, isInPredunning, userRoles } = context;

	return Boolean(
		isEditionOneOf(edition, ['standard', 'premium']) &&
		isInCollection === 'IN_COLLECTION' &&
		isProductOneOf(product, ['jira', 'confluence']) &&
		userRoles?.includes('BILLING_ADMIN') &&
		isInPredunning,
	);
}
